import { API_METHOD, apiRequest } from '../utils/apiClient';

export const inactiveAdmin = (token, adminId) =>
  apiRequest( API_METHOD.POST, `/admin/inactive/${adminId}`, token);

